export const SIZE_MAP = {
  xs: {
    height: 20,
    fontSize: 10,
    padding: 8,
    iconPadding: 8,
    iconSize: 12,
    gap: 2,
    fontWeight: 400,
  },
  sm: {
    height: 28,
    fontSize: 12,
    padding: 8,
    iconPadding: 8,
    iconSize: 12,
    gap: 4,
    fontWeight: 500,
  },
  md: {
    height: 32,
    fontSize: 14,
    padding: 12,
    iconPadding: 8,
    iconSize: 16,
    gap: 4,
    fontWeight: 500,
  },
  lg: {
    height: 40,
    fontSize: 16,
    padding: 16,
    iconPadding: 12,
    iconSize: 20,
    gap: 8,
    fontWeight: 500,
  },
  xl: {
    height: 48,
    fontSize: 16,
    padding: 20,
    iconPadding: 16,
    iconSize: 20,
    gap: 8,
    fontWeight: 500,
  },
} as const;

export type Size = keyof typeof SIZE_MAP;
